<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="用户ID" prop="userId">
          <el-input v-model="dataForm.userId" placeholder="用户ID"></el-input>
      </el-form-item>
          <el-form-item label="团队人数" prop="totalCount">
          <el-input v-model="dataForm.totalCount" placeholder="团队人数"></el-input>
      </el-form-item>
          <el-form-item label="直属人数" prop="directCount">
          <el-input v-model="dataForm.directCount" placeholder="直属人数"></el-input>
      </el-form-item>
          <el-form-item label="非直属人数" prop="secondCount">
          <el-input v-model="dataForm.secondCount" placeholder="非直属人数"></el-input>
      </el-form-item>
          <el-form-item label="累计进件" prop="totalApply">
          <el-input v-model="dataForm.totalApply" placeholder="累计进件"></el-input>
      </el-form-item>
          <el-form-item label="累计放款" prop="totalLoanAmount">
          <el-input v-model="dataForm.totalLoanAmount" placeholder="累计放款"></el-input>
      </el-form-item>
          <el-form-item label="累计津帖" prop="totalAwardAmount">
          <el-input v-model="dataForm.totalAwardAmount" placeholder="累计津帖"></el-input>
      </el-form-item>
          <el-form-item label="累计提成" prop="totalRoyaltyAmount">
          <el-input v-model="dataForm.totalRoyaltyAmount" placeholder="累计提成"></el-input>
      </el-form-item>
          <el-form-item label="累计活动奖励" prop="totalActiveAmount">
          <el-input v-model="dataForm.totalActiveAmount" placeholder="累计活动奖励"></el-input>
      </el-form-item>
              <!-- <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item> -->
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        userId: '',
        totalCount: '',
        directCount: '',
        secondCount: '',
        totalApply: '',
        totalLoanAmount: '',
        totalAwardAmount: '',
        totalRoyaltyAmount: '',
        totalActiveAmount: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        directCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        secondCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalApply: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalLoanAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalAwardAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalRoyaltyAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalActiveAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/sluserteam/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/sluserteam/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
